import React, { Component, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';


// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';

// Material components
import Drawer from '@material-ui/core/Drawer';

// Custom components
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Footer from './components/Footer';

// Component styles
import styles from './styles';

class DashboardLayout extends Component {
    constructor(props) {
        super(props);

        const isMobile = ['xs', 'sm', 'md'].includes(props.width);
        var open=true
        if(sessionStorage.getItem("openSide") && sessionStorage.getItem("openSide")==="false"){
            open=false
        }
        this.state = {
            //isOpen: !isMobile,
            isOpen: open,
            isFirstTime: this.props.isFirstTime,
            checkedA:sessionStorage.getItem('extend_view')
        };
    }

    handleClose = () => {
        this.setState({ isOpen: false });
    };

    handleToggleOpen = () => {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    };

    HandleExpand = (e) => {
                this.setState({
                    notificationsEl: null
                });
    };
    

    render() {
        const { classes, width, title, subtitle, children, callbackFromParent ,checkedA } = this.props;
        const { isOpen, isFirstTime } = this.state;
        sessionStorage.setItem("openSide", isOpen)
        const isMobile = ['xs', 'sm'].includes(width);
        const shiftTopbar = isOpen && !isMobile;
        const shiftContent = isOpen && !isMobile;

        return (
            <Fragment>
                <Topbar
                    className={classNames(classes.topbar, {
                        [classes.topbarShift]: shiftTopbar
                    })}
                    isSidebarOpen={isOpen}
                    onToggleSidebar={this.handleToggleOpen}
                    onHandleExpand={this.HandleExpand}
                    title={title}
                    //props adicionales
                    subtitle={subtitle}
                />
                <Drawer
                    anchor="left"
                    classes={{ paper: classes.drawerPaper }}
                    onClose={this.handleClose}
                    open={isOpen}
                    variant={isMobile ? 'temporary' : 'persistent'}
                >
                    
                        <Sidebar 
                            className={[classNames(classes.sidebar ),classNames(classes.customScrollBar)]} 
                            callbackFromParent={callbackFromParent} 
                            isFirstTime={isFirstTime}
                        />

                </Drawer>
                <main
                    className={classNames(classes.content, {
                        [classes.contentShift]: shiftContent
                    })}
                >
                    {children}
                    <Footer />
                </main>
            </Fragment>
        );
    }
}

DashboardLayout.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    title: PropTypes.string,
    width: PropTypes.string.isRequired
};

export default compose(
    withStyles(styles),
    withWidth()
)(DashboardLayout);
